import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  DonationSchemePayload,
  DonationSchemeRecord,
} from "@project/types/donation-scheme";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/donation-schemes`;
const SILENT: RequestConfig = { showNotification: false };

class DonationSchemeService {
  listDonationSchemesPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<DonationSchemeRecord>> => {
    return fetchListPage<DonationSchemeRecord>(`${BASE}/`, query);
  };

  getDonationScheme = async (
    id: number
  ): Promise<DonationSchemeRecord | undefined> => {
    const data = await get<
      ApiItemResponse<DonationSchemeRecord> | DonationSchemeRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (
    payload: DonationSchemePayload
  ): Promise<DonationSchemeRecord> => {
    const response = await axiosConfig.post<
      ApiItemResponse<DonationSchemeRecord> | DonationSchemeRecord
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      throw new Error("Failed to create donation scheme.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<DonationSchemePayload>
  ): Promise<DonationSchemeRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<DonationSchemeRecord> | DonationSchemeRecord,
      Partial<DonationSchemePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const donationSchemeService = new DonationSchemeService();
